import {
  type RouteLocationNamedRaw,
  type RouteLocationNormalizedGeneric,
} from 'vue-router'

export const getRedirectToLogin = (
  to: RouteLocationNormalizedGeneric
): RouteLocationNamedRaw => {
  // Special case: redirect brand-specific conversion cards to external marketing page
  if (to.name === 'brand.conversion-cards') {
    // Redirect logged-out users to the public marketing page on www.owner.com
    window.location.href = 'https://www.owner.com/how-to-use-cards'
    // Return login as fallback with redirectFrom preserved in case external redirect fails
    return {
      name: 'auth.login',
      query: {
        redirectFrom: to.fullPath,
      },
    }
  }

  return {
    name: 'auth.login',
    query: {
      redirectFrom: to.fullPath,
    },
  }
}
